import { useState } from 'react';
import { toast } from 'react-hot-toast';
import Panel from '~/components/Panel';
import AssignCSCDrawer from '~/components/CampaignDetail/drawers/AssignCSCDrawer';
import { assignPSCToCampaignRequest } from '~/services/campaign';

interface CSCPerson {
    id: number;
    first_name: string;
    last_name: string;
    email?: string;
}

interface Props {
    csc?: CSCPerson | null;
    campaignRequestId?: number;
    onReassign?: () => void;
}

const CscBlock: React.FC<Props> = ({ csc, campaignRequestId, onReassign }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    const bgColor = csc
        ? 'bg-[#e6f7f8] border-[#e6f7f8]'
        : 'bg-[#fdeaeb] border-[#fdeaeb]';

    const handleSaveCSC = async (selectedCSC: { id: number; full_name: string }) => {
        if (!campaignRequestId) {
            toast.error('Campaign Request ID is missing.');
            return;
        }

        setSaving(true);
        toast.loading('Assigning coordinator...');
        try {
            const resp = await assignPSCToCampaignRequest(campaignRequestId, selectedCSC.id);
            toast.dismiss();

            if (resp.detail) {
                toast.error(resp.detail);
                setSaving(false);
                return;
            }

            toast.success('Client Services Coordinator updated successfully');
            onReassign?.();
        } catch (e) {
            toast.dismiss();
            console.error('Error assigning CSC:', e);
            toast.error('Failed to update Client Services Coordinator');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Panel addClasses={`${bgColor} flex-1 mb-7.5`}>
                <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                    Assigned To
                </h2>
                <div
                    className={`text-[38px]/[44px] ${
                        csc ? 'font-bold' : ''
                    } text-[#131212] ${csc ? '' : 'italic'}`}
                >
                    {csc ? `${csc.first_name} ${csc.last_name}` : 'None Assigned'}
                </div>
                <div className='text-[16px]/[24px]'>
                    <button
                        className='text-[#00AEB3] hover:underline'
                        onClick={() => setDrawerOpen(true)}
                    >
                        {csc ? 'Reassign' : 'Assign'}
                    </button>
                </div>
            </Panel>

            <AssignCSCDrawer
                isOpen={drawerOpen}
                setIsOpen={setDrawerOpen}
                currentCSC={csc ? { ...csc, full_name: `${csc.first_name} ${csc.last_name}` } : null}
                handleSaveCSC={handleSaveCSC}
                saving={saving}
            />
        </>
    );
};

export default CscBlock;
